import React from 'react';
import { Checkbox } from 'antd';
import { TableCell } from '../../../../../../components/customTableComponents';

const CheckboxCell = ({
  indeterminate = false,
  checked = false,
  onChange,
  component = 'td',
  verticalAlign = 'center',
  disabled = false,
  ...props
}) => {
  return (
    <TableCell
      {...props}
      padding="checkbox"
      component={component}
      verticalAlign={verticalAlign}
      transparent
    >
      <Checkbox
        indeterminate={indeterminate}
        checked={checked}
        onChange={onChange}
        onClick={(e) => e.stopPropagation()}
        disabled={disabled}
      />
    </TableCell>
  );
};

export default CheckboxCell;
